import { useState } from "react";
import AddCertification from "./AddCertification";
import EditCertification from "./EditCertification";
import ViewCertification from "./ViewCertification";
import { FiAward, FiPlusCircle, FiEdit3, FiEye } from "react-icons/fi";

const Certifications = () => {
  const [selected, setSelected] = useState("add");

  return (
    <div className="w-full space-y-6">
      {/* 🌟 Header Banner */}
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold tracking-tight flex items-center gap-2 text-slate-900 dark:text-white">
            <FiAward className="text-indigo-600 dark:text-indigo-400" />
            <span>Student Certifications</span>
          </h1>
          <p className="text-xs md:text-sm text-slate-500 dark:text-slate-400 mt-1">Upload and manage course certifications, internships & achievements</p>
        </div>
      </div>

      {/* 🔲 Bento Pill Tabs */}
      <div className="bento-card p-2 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-800">
        <div className="grid grid-cols-3 gap-2">
          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all duration-200 cursor-pointer ${
              selected === "add"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setSelected("add")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiPlusCircle className="w-4 h-4" />
              <span>Add Certification</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all duration-200 cursor-pointer ${
              selected === "edit"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setSelected("edit")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiEdit3 className="w-4 h-4" />
              <span>Edit Certification</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all duration-200 cursor-pointer ${
              selected === "view"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setSelected("view")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiEye className="w-4 h-4" />
              <span>View Certifications</span>
            </div>
          </button>
        </div>
      </div>

      {/* 📋 Active Tab Content */}
      <div className="w-full">
        {selected === "add" && <AddCertification />}
        {selected === "edit" && <EditCertification />}
        {selected === "view" && <ViewCertification />}
      </div>
    </div>
  );
};

export default Certifications;
